<template>
  <div class="container-min-width page-home">
    <div class="des-warpper">
      <PageTemplate>
        <div class="text-warpper">
          <div class="text">
            <p>位于广东省广州市, 是一家以从事研究和试验发展为主的企业。</p>
            <p>公司开业至今已有十余年的历史，坚持以“以人为本，服务至上”为经营理念，本着坚持以客户需求为导向，坚持客户利益第一，诚信为本的经营宗旨，为客户提供所需要的一切与办公设备相关的服务。</p>
            <p>我们将秉承一贯的“服务至上、精益求精、合作进取、共赢共荣”的企业精神，全心全意为顾客提供快速、便捷、满意的服务，携手弘才，共创美好未来。 </p>
            <p>公司宗旨：以人为本，服务至上，追求用户100%满意！</p>
          </div>
        </div>
      </PageTemplate>
    </div>
    <PageTemplate>
      <div class="content-warpper">
        <div class="row">
          <div class="col" @click="tojump('find')">
            <div class="img animate__animated animate__zoomIn">
              <el-image :src="url1" fit="contain"></el-image>
            </div>
            <div class="text">1.图书检索系统 型号：HJ1</div>
          </div>
          <div style="width: 20px"></div>
          <div class="col" @click="tojump('Jiehuan')">
            <div class="img animate__animated animate__zoomIn">
              <el-image :src="url2" fit="contain"></el-image>
            </div>
            <div class="text">2.智能自助借还系统 型号：V3.0</div>
          </div>
        </div>
        <el-row style="height: 30px"></el-row>
        <div class="row">
          <div class="col" @click="tojump('Guanyuan')">
            <div class="img animate__animated animate__zoomIn">
              <el-image :src="url3" fit="contain"></el-image>
            </div>
            <div class="text">馆员工作站系统 型号：HG3</div>
          </div>
          <div style="width: 20px"></div>
          <div class="col" @click="tojump('SiShisan')">
            <div class="img animate__animated animate__zoomIn">
              <el-image :src="url4" fit="contain"></el-image>
            </div>
            <div class="text">安全门 型号：H418</div>
          </div>
        </div>
      </div>
    </PageTemplate>
    <Footer></Footer>
  </div>
</template>
<script>
import PageTemplate from '@/components/PageTemplate'
import Footer from '@/components/Footer'
export default {
  components:{PageTemplate, Footer},
  data () {
    return {
      url1: require('../assets/20220822_1.png'),
      url2: require('../assets/20220822_2.png'),
      url3: require('../assets/20220822_3.png'),
      url4: require('../assets/20220822_4.png'),
      banners: require('../assets/banners.1e39628d.jpg'),
    }
  },
  beforeCreate() {
  },
  methods : {
    tojump (path) {
      this.$router.push(`/introduction/${path}`)
    }
  }
}
</script>
<style lang="scss">
.page-home {
  .des-warpper {
    width: 100%;
    height: 460px;
    background: url(../assets/banners.1e39628d.jpg) no-repeat 100%;
    background-size: cover;
    .text-warpper {
      margin-top: 100px;
      margin-left: 200px;
      width: 800px;
      .text {
        text-align: left;
        font-size: 20px;
        line-height: 1.5;
      }
    }
  }
  .content-warpper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    // background-color: antiquewhite;
    .row {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 400px;
        &:hover {
          cursor: pointer;
        }
        .img {
          width: 500px;
          height: 340px;
          // background-color: #f2f2f2;
          .el-image {
            width: 500px;
            height: 340px;
          }
        }
        .text {
          height: 60px;
          line-height: 60px;
          text-align:center;
          font-size: 20px;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/Home.vue